const meta = {
  'verify-metrics': 'Verify metrics',
  'verify-traces': 'Verify traces',
  'monitor-collector': 'Monitor Collector',
};

export default meta;
